export function getPlatformVersionString(version) {
    var major = version.major, minor = version.minor, build = version.build;
    return "".concat(major, "_").concat(minor, "_").concat(build);
}
//# sourceMappingURL=getPlatformVersionString.js.map